module.exports = __webpack_public_path__ + "img/ic_20_facebook.14cc8589.svg";